export default "/images/28fde78a1e89d29207006b4cdfee9cc1.avif";